/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = Sales
 *
 * 1 = Service
 *
 * 2 = Parts
 */
export enum BranchBrandTypes {
  Sales = 0,
  Service = 1,
  Parts = 2,
}
